/* IMPORTANT: this is a web component, so it will need a bundle created on this file and promoted for changes */


/*
** TO IMPLEMENT:
** [color]: the color of the slant (red, dkRed, yellow, green, teal, blue or purple)
** [slant-location]:  (optional) default is a slant located on the right. If this is added to the element, slant-location="left" works
** Note: this can also include an img after the <p slot> if needed

 <article-quote color="teal">
	<p slot="quote">The quote text here <span class="textSemiBold">they can style it however they want with bold/semibold</span>.</p>
 </article-quote>
 */

 class ArticleQuote extends HTMLElement {
      	constructor() {
         	super();

			this.quartzPath = "https://4imprintweb.blob.core.windows.net/qtzdev";
     	}
     	
 	static get observedAttributes() {
		return ['color', 'slant-location'];
	}
	get color() {
        	return this.getAttribute('color') || "blue";
    	}
	set color(value) { 
		this.setAttribute('color', value);
	}
	get slantLocation() {
        	return this.getAttribute('slant-location') || "right";
    	}
	set slantLocation(value) { 
		this.setAttribute('slant-location', value);
	}

     	connectedCallback() {
         	const style = document.createElement("style");
         	style.textContent = `
            :host{
				--host-wrapper-padding: 1.25rem;
				--quote-textSize: 1.25rem;
				--quote-image-width: 25%;
				--quote-width-noImage: 100%;
				--left-quote-padding-noImage: 0;
				--quote-width-withImage: 80%;
				--redTriangle: right 100% no-repeat url(${this.quartzPath}/blog/images/general/background/redslant.svg);
				--dkRedTriangle: right 100% no-repeat url(${this.quartzPath}/blog/images/general/background/dkredslant.svg);
				--yellowTriangle: right 100% no-repeat url(${this.quartzPath}/blog/images/general/background/yellowslant.svg);
				--greenTriangle: right 100% no-repeat url(${this.quartzPath}/blog/images/general/background/greenslant.svg);
				--tealTriangle: right 100% no-repeat url(${this.quartzPath}/blog/images/general/background/tealslant.svg);
				--blueTriangle: right 100% no-repeat url(${this.quartzPath}/blog/images/general/background/blueslant.svg);
				--purpleTriangle: right 100% no-repeat url(${this.quartzPath}/blog/images/general/background/purpleslant.svg);

				--redTriangleLeft: left 100% no-repeat url(${this.quartzPath}/blog/images/general/background/redslantleft.svg);
				--dkRedTriangleLeft: left 100% no-repeat url(${this.quartzPath}/blog/images/general/background/dkredslantleft.svg);
				--yellowTriangleLeft: left 100% no-repeat url(${this.quartzPath}/blog/images/general/background/yellowslantleft.svg);
				--greenTriangleLeft: left 100% no-repeat url(${this.quartzPath}/blog/images/general/background/greenslantleft.svg);
				--tealTriangleLeft: left 100% no-repeat url(${this.quartzPath}/blog/images/general/background/tealslantleft.svg);
				--blueTriangleLeft: left 100% no-repeat url(${this.quartzPath}/blog/images/general/background/blueslantleft.svg);
				--purpleTriangleLeft: left 100% no-repeat url(${this.quartzPath}/blog/images/general/background/purpleslantleft.svg);

				display: block;
				background: var(--ltGray);
				margin: 0.625rem 0;
				-webkit-border-radius: 0.3125rem;
				border-radius: 0.3125rem;
			}
			:host > div{
				-webkit-border-radius: 0 0.3125rem 0.3125rem 0;
				border-radius: 0 0.3125rem 0.3125rem 0;
				display: -webkit-flex;
				display: flex;
				-webkit-align-items: flex-start;
				align-items: flex-start;
				-webkit-flex-wrap: nowrap;
				flex-wrap: nowrap;
				-webkit-align-items: center;
				align-items: center;
				-webkit-justify-content: space-between;
				justify-content: space-between;
				padding: var(--host-wrapper-padding);
			}
			.imgWrap{
				width: var(--quote-image-width);
			}
			.quoteElement{ 
				width: var(--quote-width-noImage);
				font-size: var(--quote-textSize);
				color: var(--blue);
			}
	             
			:host > div:has(.imgWrap) .quoteElement{
				width: var(--quote-width-withImage);
			}
			
			:host([slant-location="left"]) > div {
				 -webkit-border-radius: 0.3125rem 0 0 0.3125rem;
				border-radius: 0.3125rem 0 0 0.3125rem;
			}
			:host([slant-location="left"]) .quoteElement{
				padding-left: var(--left-quote-padding-noImage);
			}
			:host([slant-location="left"]) > div:has(.imgWrap) .quoteElement{
				padding-left: 0;
			}
			
			::slotted(img){
				max-width: 100%;
				height: auto;
				width: auto;
				max-height: 12rem;
			}
	             				
			@media (min-width: 1000px) {
				:host{
					--host-wrapper-padding: 1.875rem;
					--quote-image-width: 20%;
					--quote-width-noImage: 81%;
					--quote-width-withImage: 75%;
					--left-quote-padding-noImage: 25%;
				}
				::slotted(img){ margin: 0 1.875rem 0 0; }
				:host([color="red"]) > div{ background: var(--redTriangle); }
				:host([color="dkRed"]) > div{ background: var(--dkRedTriangle); }
				:host([color="yellow"]) > div{ background: var(--yellowTriangle); }
				:host([color="green"]) > div{ background: var(--greenTriangle); }
				:host([color="teal"]) > div{ background: var(--tealTriangle); }
				:host([color="blue"]) > div{ background: var(--blueTriangle); }
				:host([color="purple"]) > div{ background: var(--purpleTriangle); }
			
				:host([color="red"][slant-location="left"]) > div{ background: var(--redTriangleLeft); }
				:host([color="dkRed"][slant-location="left"]) > div{ background: var(--dkRedTriangleLeft); }
				:host([color="yellow"][slant-location="left"]) > div{ background: var(--yellowTriangleLeft); }
				:host([color="green"][slant-location="left"]) > div{ background: var(--greenTriangleLeft); }
				:host([color="teal"][slant-location="left"]) > div{ background: var(--tealTriangleLeft); }
				:host([color="blue"][slant-location="left"]) > div{ background: var(--blueTriangleLeft); }
				:host([color="purple"][slant-location="left"]) > div{ background: var(--purpleTriangleLeft); }
			}

     		`;
     		
		const html = document.createElement("div");
		let quoteHTML = "";
		if(this.slantLocation == "left"){
			// add the image HTML only if necessary
			if(this.querySelector("img")){
				quoteHTML += `<div class="imgWrap"><slot></slot></div>`;
			}
			quoteHTML += `<div class="quoteElement"><slot name="quote"></slot></div>`;
		}else{
			quoteHTML += `<div class="quoteElement"><slot name="quote"></slot></div>`;
			// add the image HTML only if necessary
			if(this.querySelector("img")){
				quoteHTML += `<div class="imgWrap"><slot></slot></div>`;
			}
		}
		html.innerHTML = quoteHTML;
		
		this._shadowRoot = this.attachShadow({ mode: "open" });
		this._shadowRoot.appendChild(style);
		this._shadowRoot.appendChild(html);
     	}
     	
     	attributeChangedCallback(attrName, oldValue, newValue) {
		if (newValue !== oldValue) {
			switch (attrName) {
				case 'color':
				case 'slant-location':
					this[attrName] = this.getAttribute(attrName);
					break;
			}
		}
	}
}

customElements.define('article-quote', ArticleQuote);